import React from 'react';

function Stripe({ width }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || '65'} viewBox="0 0 65 34" fill="none">
      <g clipPath="url(#striperrngj8ds)">
        <path
          d="M13.2 14.45c0-.5.41-.69 1.09-.69.96 0 2.18.3 3.14.81V11.6a8.37 8.37 0 0 0-3.14-.58C11.7 11 10 12.35 10 14.6c0 3.5 4.82 2.94 4.82 4.45 0 .58-.5.77-1.22.77a7.9 7.9 0 0 1-3.46-1.01v3.02a8.8 8.8 0 0 0 3.46.72c2.64 0 4.45-1.3 4.45-3.58 0-3.78-4.84-3.1-4.84-4.52Zm8.58-5.98-3.1.66V19.3c0 1.88 1.4 3.26 3.28 3.26a4.9 4.9 0 0 0 2.22-.42v-2.57c-.4.16-2.41.75-2.41-1.13v-4.5h2.41v-2.7h-2.41l.01-2.76Zm6.34 3.7-.2-.95h-2.74v11.1h3.17V14.8c.75-.98 2.02-.8 2.41-.66v-2.92c-.4-.15-1.89-.43-2.64.94Zm3.42-.95h3.18v11.1h-3.18v-11.1Zm0-.96 3.18-.69V7l-3.18.67v2.59Zm9.8.75c-1.24 0-2.04.58-2.48.99l-.17-.79H35.9V26l3.17-.67.01-3.6c.46.34 1.13.8 2.25.8 2.27 0 4.34-1.82 4.34-5.84-.02-3.68-2.1-5.68-4.33-5.68Zm-.76 8.74a1.9 1.9 0 0 1-1.5-.6v-4.7c.32-.37.78-.63 1.5-.63 1.15 0 1.95 1.3 1.95 2.96 0 1.7-.78 2.97-1.95 2.97Zm15.08-2.93c0-3.25-1.57-5.81-4.58-5.81-3.02 0-4.84 2.56-4.84 5.78 0 3.82 2.15 5.75 5.25 5.75 1.5 0 2.65-.34 3.51-.83v-2.53c-.86.43-1.85.7-3.1.7-1.24 0-2.33-.44-2.47-1.93h6.2l.03-1.13Zm-6.26-1.2c0-1.44.87-2.04 1.67-2.04.77 0 1.6.6 1.6 2.03H49.4Z"
          fill="#6772E5"
        />
      </g>
      <defs>
        <clipPath id="striperrngj8ds">
          <path
            d="M.85 4a4 4 0 0 1 4-4h56a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4h-56a4 4 0 0 1-4-4V4Z"
            fill="#fff"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Stripe;
